module.exports = __webpack_public_path__ + "img/pop_imge.437cfdcd.png";